import React, {FC} from 'react';
import Modal from "./ui/Modal";
import {useTranslation} from "react-i18next";
import {IFile} from "../types/gpsr-questions";

interface ICurrentQuestionIDS {
    topicID: string;
    questionID: string;
    pointID: string;
}

interface GpsrDeleteProductFileModalProps {
    open: boolean;
    onClose: () => void;
    currentQuestionIDs: ICurrentQuestionIDS;
    fileName: string;
    originalFileName: string;
    deleteFileHandle: (topicID: string, questionID: string, pointID: string, file: IFile) => void;
}

const GpsrDeleteProductFileModal: FC<GpsrDeleteProductFileModalProps> = ({open, onClose, fileName, originalFileName, currentQuestionIDs, deleteFileHandle}) => {
    const {t} = useTranslation();

    const confirmDeleteFileHandle = () => {
        const {topicID, questionID, pointID} = currentQuestionIDs
        const files = {
            name: fileName,
            originalName: originalFileName,
        }
        onClose()
        deleteFileHandle(topicID, questionID, pointID, files)
    }

    return (
        <Modal hideCloseButton={true} isCentered={true} isOpen={open} onClose={onClose} title={t('gpsr:delete_file_modal_title')}>
            <div className='gpsr-modal-body-wrapper'>
                <div className='gpsr-modal-body-text'>
                    <span>{t('gpsr:delete_file_modal_body_prefix')}</span>
                    {t('gpsr:delete_file_modal_body_text', {fileName: originalFileName})}
                </div>

                <div className='gpsr-modal-body-buttons'>
                    <button onClick={onClose} className='modal-button cancel-delete'>
                        {t('cancelText')}
                    </button>

                    <button className='modal-button confirm-delete ml-24' onClick={confirmDeleteFileHandle}>
                        {t('gpsr:delete_file_modal_delete_button_text')}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default GpsrDeleteProductFileModal;